/** Product name (Parallax Gate): set VITE_APP_NAME to override without touching components. Logos render it uppercase via CSS. */
export const APP_NAME: string = (import.meta.env['VITE_APP_NAME'] as string | undefined) ?? 'Parallax Gate';
